export const normalizeSearchQuery = (query = '') => String(query || '').trim().toLowerCase();

export const matchesSearchTerm = (value = '', query = '') => {
  const normalizedQuery = normalizeSearchQuery(query);
  if (!normalizedQuery) return true;
  return String(value || '').toLowerCase().includes(normalizedQuery);
};

export const filterEntriesBySearch = (entries = [], query = '') => {
  if (!Array.isArray(entries)) return [];
  return entries.filter((entry) => matchesSearchTerm(entry?.name, query));
};

export const countSearchResults = (entries = [], query = '') => filterEntriesBySearch(entries, query).length;

export const getHighlightedSegments = (value = '', query = '') => {
  const text = String(value || '');
  const normalizedQuery = normalizeSearchQuery(query);

  if (!normalizedQuery) {
    return [{ text, highlight: false }];
  }

  const normalizedText = text.toLowerCase();
  const firstMatchIndex = normalizedText.indexOf(normalizedQuery);
  if (firstMatchIndex === -1) {
    return [{ text, highlight: false }];
  }

  const segments = [];
  let cursor = 0;
  let matchIndex = firstMatchIndex;

  while (matchIndex !== -1) {
    if (matchIndex > cursor) {
      segments.push({ text: text.slice(cursor, matchIndex), highlight: false });
    }

    const nextCursor = matchIndex + normalizedQuery.length;
    segments.push({
      text: text.slice(matchIndex, nextCursor),
      highlight: true,
    });

    cursor = nextCursor;
    matchIndex = normalizedText.indexOf(normalizedQuery, cursor);
  }

  if (cursor < text.length) {
    segments.push({ text: text.slice(cursor), highlight: false });
  }

  return segments;
};
